
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useProgressLevelList } from '@/modules/progress/level/model/list';
import { getItemRouterLink, progressLevelTypeOption } from '@/modules/progress/level/model/mixins';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.LEVEL.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { progressId, list, total, fetchList, actions } = useProgressLevelList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Level', key: 'level' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: progressLevelTypeOption },
                { type: TableColumnType.Text, label: 'Reward', key: 'reward' },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Item Id',
                    key: 'itemId',
                    to: (row: any) => getItemRouterLink(row.type, row.itemId)
                },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PROGRESS.LEVEL.EDIT, params: { progressId, level: row.level } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_PROGRESS.LEVEL.TRANSLATE, params: { progressId, level: row.level } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(progressId, row.level)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, progressId, ROUTE_NAME_PROGRESS };
    }
});
